import Navbar from "../../components/Navbar";
import {Photo, RowsPhotoAlbum} from "react-photo-album";
import "react-photo-album/rows.css"
import "./css/gallery.css"
import {useEffect, useState} from "react";
import {API_URL, EVENT_NAME, USER_ID} from "../../constants/ApiConstants";

type ImageResponse = {
    items:Image[];
}

interface Image extends Photo {
    id: string
    parentId: number
    imageType: string
    fileName: string
    parentType: string
}

const Gallery = () => {
    const [pictureData, setPictureData] = useState<Image[]>([])

    useEffect(() => {
        loadData().then(ret => {
            if (ret) {
                const newImages:Image[] = [];

                ret.items.forEach(i => {
                    i.src = `${API_URL}/${i.src}`
                    newImages.push(i);
                });

                setPictureData(newImages);
            }
        });
    },  [])

    const loadData = async ():Promise<ImageResponse | undefined> => {
        const requestOptions: RequestInit = {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include",
        }

        const url = new URL(`${API_URL}/users/${USER_ID}/events/${EVENT_NAME}/images?type=event_gallery`);

        try {
            const response = await fetch(url, requestOptions);

            if (response.ok) {
                return await response.json();
            }
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <main className="gallery">
            <Navbar/>

            <div className="container gallery__container">


                <div className="container gallery__content">
                    <div className="gallery__header">
                        <h1 className="text-cursive">Photo Gallery</h1>
                        <hr/>
                    </div>
                    <RowsPhotoAlbum photos={pictureData}/>
                </div>
            </div>
        </main>
    )
};

export default Gallery;